<template>
    <div class="titan-acl-switch"
         :class="getStyleClass()"
         v-on:click="$emit('change', !val); val = !val"
    >
        <span v-if="val !== false">{{ yes }}</span>
        <span v-if="val === false">{{ no }}</span>
    </div>
</template>
<script>
    export default {
        props: {
            value: Boolean
        },
        mounted() {
            this.val = this.value;
        },
        watch: {
            '$props.value'() {
                this.val = this.value;
            }
        },
        methods: {
            getStyleClass: function () {
                if (this.val === false) {
                    return 'switch-off ' + this.falseBackground;
                }
                return 'switch-on ' + this.trueBackground;
            },
        },
        data() {
            return {
                val: {},
                trueBackground: 'bg-success',
                falseBackground: 'bg-danger',
                yes: 'Yes',
                no: 'No',
            };
        }
    };
</script>
<style lang="scss" scoped>
    .titan-acl-switch {
        height: 25px;
        width: auto;
        display: inline-block;
        color: #fff;
        line-height: 25px;
        cursor: pointer;
        position: relative;
        padding: 0 5px 0 20px;
        border-radius: 4px;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;

        &:before {
            content: '';
            position: absolute;
            top: 4px;
            left: 4px;
            right: auto;
            bottom: 4px;
            width: 12px;
            background: #fff;
            border-radius: 3px;
        }

        &.switch-off {
            padding: 0 20px 0 5px;

            &:before {
                right: 4px;
                left: auto;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/admin/Components/AclSwitch.vue